import { float } from './float'

function int(unknown: unknown): number {
  return float(unknown, 0)
}

export { int }
